interface SignaterSquareLogoProps {
  className?: string
  size?: number
}

// Paths lifted verbatim from logos/Rev4/logo.svg. Inline rather than an asset
// import on purpose: the mark ships inside the hashed JS chunk, so it costs no
// request and never flashes — unlike the wordmark, which needs a real file
// because account-switcher.tsx also uses it as a CSS mask.
export function SignaterSquareLogo({
  className,
  size = 32,
}: SignaterSquareLogoProps) {
  return (
    <svg
      version="1.1"
      viewBox="0 0 1024 1024"
      width={size}
      height={size}
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        transform="translate(260)"
        d="m0 0h509l42 4 33 5 20 5 20 7 23 12 15 10 13 10 15 13 13 13 11 14 9 12 8 13 12 23 7 20 6 26 4 28 4 49v490l-3 43-3 27-5 27-5 18-6 16-8 16-11 18-9 12-11 13-11 12-12 11-17 13-19 12-16 8-16 7-21 6-28 5-35 4-28 2h-491l-32-2-43-5-25-5-17-5-20-8-16-9-18-12-11-9-10-9-8-7-12-13-12-15-11-17-12-23-6-15-6-22-4-22-3-23-3-37v-512l5-49 4-25 5-20 6-17 10-21 12-19 10-13 13-15 15-15 11-9 15-11 15-9 17-9 21-8 26-6 27-4 31-3z"
        fill="#F1D430"
      />
      <path
        transform="translate(508,210)"
        d="m0 0h36l24 2 25 4 26 6 26 8 28 11 32 16 23 14 16 11 18 13 2 2-1 4-7 8-9 11-4 5-5-1-12-10-12-8-14-9-19-11-27-13-21-8-31-9-25-5-21-3-14-1h-35l-21 2-26 5-24 8-21 11-14 10-12 11h-2l-2 4-10 11-10 15-8 16-6 18-4 20v27l4 20 7 19 9 17 13 16 7 7 14 11 16 9 19 8 21 6 34 6 39 6 31 7 22 8 16 9 14 11 9 11 8 14 6 14 1 5h-37l-4-4-8-11-8-7-16-9-21-7-28-6-51-8-24-5-20-6-18-8-14-8-12-8-11-9-10-9-11-12-11-16-11-21-7-21-4-19-1-10v-28l4-24 5-18 9-21 8-14 10-14 12-14 11-11 14-11 15-10 21-11 18-7 28-7 28-4z"
        fill="#000000"
      />
      <path
        transform="translate(388,413)"
        d="m0 0h37l7 10 7 8 8 6 16 8 18 6 23 5 57 9 26 6 21 7 16 7 17 10 12 9 10 9 5 4 7 8 13 16 13 24 8 24 4 20 1 10v22l-2 19-5 20-8 21-10 19-13 18-12 13-13 13-16 12-15 9-21 10-21 7-22 5-32 4h-52l-34-4-25-5-25-7-32-12-29-14-20-11-27-18-13-10-7-6 1-4 3-1 2-4 8-10 6-8 5 1 19 14 23 15 16 9 25 12 29 11 25 7 25 5 22 3 13 1h33l27-3 20-4 23-7 22-11 14-10 10-8 12-12 10-13 9-15 6-13 5-15 4-20v-26l-3-17-7-21-10-18-8-11-5-5v-2h-2v-2h-2v-2l-4-2-9-8-18-11-21-9-21-6-28-5-49-8-23-5-21-7-16-8-11-7-11-10v-2h-2l-10-15-7-16z"
        fill="#000000"
      />
      <path
        transform="translate(510,136)"
        d="m0 0h47l30 3 29 5 25 6 26 8 24 9 27 12 22 12 11 7-6 8-11 19-4 3-13-8-24-12-26-11-31-10-28-7-24-4-31-3h-50l-36 4-28 6-23 7-18 8-21 11-7 5h-2l-18-27 1-3 22-12 21-10 24-9 25-7 31-6 24-3z"
        fill="#000000"
      />
      <path
        transform="translate(293,794)"
        d="m0 0 5 2 11 7 23 11 18 8 36 12 22 6 36 6 18 2 16 1h38l37-4 26-5 24-7 20-8 25-13 5-4 4 2 16 24-1 4-18 10-21 10-23 9-23 7-27 6-29 4-31 2h-21l-30-2-35-5-31-7-29-9-21-8-25-11-15-8-18-11-1-3 9-14 8-12z"
        fill="#000000"
      />
      <path
        transform="translate(724,469)"
        d="m0 0 5 1 7 8 8 9 8 12 9 15 9 19 9 24 6 22 4 20 3 27v29l-3 26-5 23-8 23-9 19-10 17-10 13-18 20-8 7-8 6-4-2-8-10-9-11-3-3 1-4 13-11 7-7 11-14 10-15 11-23 6-19 5-24 1-8v-36l-4-28-8-30-9-22-8-16-9-14-8-10-6-6 1-4 12-13z"
        fill="#000000"
      />
      <path
        transform="translate(310,213)"
        d="m0 0h4l8 11 12 14v4l-11 10-7 6-9 11-11 15-12 23-7 21-4 17-3 20v37l4 26 5 21 6 18 9 20 10 18 9 12 9 9-2 4-11 13-8 8-1 2-4-1-10-10-10-13-8-13-8-14-12-28-7-23-5-22-3-24-1-12v-21l3-30 5-24 7-21 8-18 8-14 9-13 8-10 12-13 15-14z"
        fill="#000000"
      />
      <path
        transform="translate(508,284)"
        d="m0 0h25l23 2 30 5 25 6 36 12 29 12 9 5-2 5-13 25-3 2-13-6-23-9-27-9-24-6-28-5-17-2h-32l-19 3-18 6-13 7-10 8-7 8-8 14-5 15-36-1 1-10 7-21 9-16 10-13 11-10 16-10 15-7 16-5 15-3z"
        fill="#000000"
      />
      <path
        transform="translate(601,640)"
        d="m0 0h36l-1 11-6 18-7 14-10 14-11 11-16 11-19 9-17 5-24 4-24 1-31-2-26-4-28-6-27-8-21-8-18-8-12-6 2-6 12-23 1-2 7 1 26 11 33 11 24 6 29 5 23 2h21l21-3 16-5 16-8 13-10 9-13 5-11z"
        fill="#000000"
      />
      <path
        transform="translate(473,370)"
        d="m0 0h40l26 3 27 6 27 8 32 13 17 8 24 14 17 11 14 10 11 8-6 7-9 11-8 10-4-2-5-4-18-13-24-14-28-14-23-9-26-8-28-6-32-3h-9l-19 1-9-9v-9l4-11 5-6z"
        fill="#000000"
      />
      <path
        transform="translate(339,543)"
        d="m0 0 6 4 18 13 21 13 27 14 27 11 22 7 25 6 19 3 11 1h38l5 3 5 4 1 2v7l-4 12-7 8-6 1h-32l-26-3-31-6-27-8-22-9-25-11-24-14-16-10-15-11-12-9 1-4 5-4 4-6 3-4h2v-2l4-4z"
        fill="#000000"
      />
      <path
        transform="translate(268,586)"
        d="m0 0 4 2 8 10 18 18 11 9 16 12 7 5-1 4-16 24-2 2-4-1-16-12-9-7-13-11-19-19-9-11-2-3 5-5 12-9z"
        fill="#000000"
      />
      <path
        transform="translate(710,350)"
        d="m0 0 4 1 19 13 10 9 11 9 18 18 9 11 1 4-16 13-11 8-5-4-8-10-16-16-14-11-10-8-10-7 1-5 7-10z"
        fill="#000000"
      />
      <path
        transform="translate(510,136)"
        d="m0 0h47l8 1v1l-57 1-23 2h-7v2l-20 1 4-2 26-4z"
        fill="#000000"
      />
      <path
        transform="translate(740,192)"
        d="m0 0 8 4 3 3-6 7-3 3-2-6-1-6-1-2z"
        fill="#000000"
      />
      <path
        transform="translate(733,216)"
        d="m0 0h3 2l-2 6-5 6-5-3-1-3 3-3h3v-2z"
        fill="#000000"
      />
      <path
        transform="translate(348,677)"
        d="m0 0 4 1-6 11-2 6-5 1 2-6z"
        fill="#000000"
      />
      <path
        transform="translate(370,204)"
        d="m0 0h2l4 4v2l-6 4h-2l-3-5v-2l5-1z"
        fill="#000000"
      />
      <path
        transform="translate(601,641)"
        d="m0 0h35l-3 3-2-1h-30z"
        fill="#000000"
      />
      <path
        transform="translate(760,297)"
        d="m0 0 1 2h2l-2 4-4 1-2-2 2-4z"
        fill="#000000"
      />
      <path
        transform="translate(398,240)"
        d="m0 0 4 1-4 3h-2l-1 3-4 1 5-7z"
        fill="#000000"
      />
      <path
        transform="translate(327,642)"
        d="m0 0h5l-1 4-2 3h-2z"
        fill="#000000"
      />
      <path
        transform="translate(751,429)"
        d="m0 0h7l-2 4-4 1z"
        fill="#000000"
      />
    </svg>
  )
}
